import { useContext } from 'react';

import { CostReportContext } from '../providers/CostReportProvider';

export const useCostReportContext = () => {
  return useContext(CostReportContext);
};
